import React, { Suspense, lazy } from 'react'
import { Switch, Route } from 'react-router-dom'
import TripListDesktop from 'AccountsContainers/Trips/TripListDesktop'
import {
  LOAD_CANCELLATION,
  LOAD_TRIP_DETAILS,
  LOAD_TRIP_LIST,
  TRIP_NOT_FOUND
} from 'AccountsConstants/routes'
import PageLoader from 'Lib/Pageloader'
import { isInFlyinDomain } from 'AccountsUtils'
import FlyinFooter from './components/Desktop/FlyinFooter'
import Wallet from './components/Desktop/Wallet'
import Expressway from './containers/Expressway'
import OldShell from './pages/OldShell'
import PageNotFound from './containers/PageNotFound'
import TripNotFound from './containers/TripNotFound'
import MobileDeviceSupport from './components/Support/MobileDeviceSupport'
import HiFive from './containers/HiFive'
import Profile from './containers/Profile'

const Cancellation = lazy(() => import('AccountsContainers/Trips/Cancellation'))
const TripDetails = lazy(() => import('./pages/Trips/TripDetails'))

const router = props => {
  const { match } = props

  return (
    <Switch>
      <Route
        exact={true}
        path={`${match.url}${LOAD_TRIP_LIST}`}
        render={routeProps => (
          <OldShell {...routeProps}>
            <TripListDesktop match={match} isPWA={false} {...routeProps} />
          </OldShell>
        )}
      />
      <Route
        exact={true}
        path={`${match.url}${LOAD_TRIP_DETAILS}`}
        render={routeProps => (
          <Suspense fallback={(<PageLoader title="Loading..." message="Please wait" />)}>
            <TripDetails match={match} isPWA={false} {...routeProps} />
          </Suspense>
        )}
      />
      <Route
        exact={true}
        path={`${match.url}/contactUs`}
        component={MobileDeviceSupport}
      />
      <Route
        exact={true}
        path={`${match.url}${LOAD_CANCELLATION}`}
        render={routeProps => (
          <Suspense fallback={(<PageLoader title="Loading..." message=" " />)}>
            <OldShell {...routeProps}>
              <Cancellation match={match} isPWA={false} {...routeProps} />
            </OldShell>
          </Suspense>
        )}
      />
      <Route
        exact={true}
        path={`${match.url}${TRIP_NOT_FOUND}`}
        render={routeProps => (
          <OldShell {...routeProps}>
            <TripNotFound match={match} isPWA={false} {...routeProps} />
          </OldShell>
        )}
      />
      <Route
        path={`${match.url}/hi-five`}
        render={routeProps => (
          <OldShell {...routeProps} section="hifive">
            <HiFive />
          </OldShell>
        )}
      />

      <Route
        path={`${match.url}/expressway`}
        render={routeProps => (
          <OldShell {...routeProps} section="express_tab">
            <Expressway />
          </OldShell>
        )}
      />

      <Route
        path={`${match.url}/profile`}
        render={routeProps => (
          <OldShell {...routeProps} section="profile_tab">
            <Profile />
          </OldShell>
        )}
      />

      <Route
        path={`${match.url}/wallet`}
        render={routeProps => (
          <>
            <OldShell {...routeProps} section="wallet_tab">
              <Wallet />
            </OldShell>
            {isInFlyinDomain() ? <FlyinFooter /> : <></>}
          </>
        )}
      />

      <Route
        path="*"
        render={routeProps => (
          <OldShell {...routeProps}>
            <p>{match.url}</p>
            <PageNotFound match={match} isPWA={false} {...routeProps} />
          </OldShell>
        )}
      />

    </Switch>
  )
}
export default router
